(function(w, d) {
    if (typeof NodeList.prototype.forEach !== "function") { NodeList.prototype.forEach = Array.prototype.forEach; }
    var dycol = {
        init: function () {
            w.dycol_config.forEach(function(o) {
                
                var trigger = d.getElementById(o.trigger),
                    fetchUrl = __tnt.scrubUrl(o.search_url),
                    mapContainer = d.getElementById('collection-map-dynamic-' + o.uuid),
                    page = 0,
                    complete = false;
                
                // Load more trigger
                trigger.addEventListener("click", function(e){
                    spinnerControl();
                    if (complete === true) {
                        // Hide/show existing maps
                        pageManagement();
                    } else{
                        // Fetch new map assets
                        fetchAssets(spinnerControl);
                    }
                });
                
                /** Fetch assets */
                fetchAssets(spinnerControl);
                
                 // Toggle visibility
                function toggle(el) {
                    if (typeof el !== "undefined") {
                        var display = (w.getComputedStyle ? getComputedStyle(el, null) : el.currentStyle).display;
                        if (display == "none") {
                            el.style.display = "";
                        } else {
                            el.style.display = "none";
                        }
                    }
                }
                
                // Spinner display
                function spinnerControl() {
                    var loaderText = d.querySelectorAll(o.trigger_text);
                    if (typeof loaderText !== "undefined") {
                        for (i = 0; i < loaderText.length; ++i) {
                            toggle( loaderText[i] );
                        }
                    }
                }
                
                // Page management
                function pageManagement() {
                    // Get active
                    var activePage = d.querySelector(".map-canvas-dynamic.active"),
                        nextPage = activePage.nextSibling ? activePage.nextSibling : mapContainer.firstChild;
                    
                    // Hide active
                    activePage.classList.remove("active");
                    activePage.classList.add("hidden");
                    
                    // Show next
                    nextPage.classList.remove("hidden");
                    nextPage.classList.add("active");
                    
                    // Spinner
                    spinnerControl();
                }
                
                // Fetch assets
                function fetchAssets(callback) {
                    fetch(fetchUrl)
                        .then(function(response) {
                            if (response.status !== 200) {
                                __tnt.log("Error. Status Code: " + response.status);
                                removeTrigger();
                                return;
                            }
                        // Examine response
                        response.json()
                            .then(function(data) {
                                
                                // Track virtual pageview
                                if (fetchUrl.includes("page=")) {
                                    __tnt.trackEvent( {'url': o.url, 'title': o.title} ); 
                                }

                                // Generate map
                                generateMap(data.assets);
                                
                                // Prepare for next run
                                if (data.next_url !== null) {
                                    fetchUrl = __tnt.scrubUrl(data.next_url);
                                } else {
                                    // End of results reached
                                    complete = true;
                                    
                                    // No paging needed
                                    if (page === 1) removeTrigger();
                                }
                                
                                // Observer callback
                                if (typeof callback === "function") {
                                    callback();
                                }
                        });
                    })
                    .catch(function(err) {
                        __tnt.log("Fetch Error: ", err);
                        removeTrigger();
                    });
                }
                
                // Generate map
                function generateMap(assets) {
                    var locationData = [],
                        itemData = {},
                        count = 0;
                    
                    /** Prepare assets */
                    if (assets) {
                        // Gather location data of each item
                        assets.forEach(function(asset) {
                            // Create DOM element for injection
                            var df = d.createDocumentFragment(),
                                card = d.createElement("div");
                            
                            // Set up card content
                            card.innerHTML = asset.content;
                            
                            // Scrub for preview
                            if (preview()) {
                                card = previewScrub(card);
                            }
                            
                            // Add card to document fragment
                            df.appendChild(card);
                            
                            // Get card data
                            var mapCard = df.querySelector(".inline-summary");
                            if (mapCard) {
                                var lat = mapCard.dataset.lat,
                                    lon = mapCard.dataset.lon,
                                    address = mapCard.dataset.address,
                                    icon_fill = mapCard.dataset.iconFill,
                                    icon_classes = mapCard.dataset.iconClasses;
                            }
                            
                            // Assign values for map
                            if (lat && lon || address) {
                                // Increment count for map icon
                                count++;
                                
                                // Prepare asset data for map
                                itemData = {
                                    "address": address,
                                    "lat": lat,
                                    "lon": lon,
                                    "html": mapCard,
                                    "icon_fill": icon_fill,
                                    "icon_classes": icon_classes,
                                    "label": count
                                };
                                
                                // Push assets to location array
                                locationData.push(itemData);
                            }
                        });
                    } else {
                        __tnt.log("Dynamic collection error: Unexpected JSON response.");
                        removeTrigger();
                    }
                    
                    /** No locations available */
                    if (count === 0) {
                        // Remove trigger
                        if (page <= 1) {
                            removeTrigger();
                            // Show no content alert
                            mapContainer.innerHTML = "<p class='alert alert-info'>No maps are available at this time. Please check back later.</p>";
                        } else if (complete === false) {
                            // Look in next set
                            fetchAssets(spinnerControl);
                        } else {
                            // No more sets. Run through existing pages
                            pageManagement();
                        }
                        
                        // Do not attempt to generate map
                        return;
                    }
                    
                    // Hide previous map page
                    var prevPage = d.getElementById(o.vendor + "-map-container-" + o.uuid + '-' + page);
                    if (prevPage) {
                        prevPage.classList.remove("active");
                        prevPage.classList.add("hidden");
                    }
                    
                    // Increment page
                    page++;
                    
                    // Create new map page
                    var mapPage = d.createElement("div");
                    mapPage.setAttribute("id", o.vendor + "-map-container-" + o.uuid + '-' + page);
                    mapPage.classList.add("map-canvas", "map-canvas-dynamic", "multi-location", "active");
                    mapContainer.append(mapPage);
                    
                    /* Populate new map */
                    if(o.vendor == 'google') {
                        // Google map
                        var map = new __tnt.map.google({
                            id: o.uuid,
                            locations: locationData,
                            map_id: o.vendor + "-map-container-" + o.uuid + '-' + page,
                            icon_fill: "#ea4335",
                            draggable_mobile: true,
                            street_view: true,
                            use_latlng: true
                        });
                    } else if (o.vendor == 'here') {
                        // Here map
                        var map = new __tnt.map.here({
                            id: o.uuid,
                            locations: locationData,
                            app_id: o.app_id,
                            app_code: o.app_code,
                            api_key: o.api_key,
                            map_id: o.vendor + "-map-container-" + o.uuid + '-' + page,
                            static: false,
                            icon_fill: "#ea4335",
                            use_latlng: true
                        });
                    }
                }
                
                // Remove trigger
                function removeTrigger() {
                    trigger.parentNode.removeChild(trigger);
                }
                
                // Preview
                function preview() {
                    return window.location.pathname.indexOf("/tncms/admin/action/main/preview/site");
                }
                
                // Preview scrub
                function previewScrub(content) {
                    content.querySelectorAll(".tnt-asset-link").forEach(function(link) {
                        let href = link.getAttribute("href");
                        link.setAttribute("href", __tnt.scrubUrl(href));
                    });
                    return content;
                }
            });
        }
    };
    if (d.readyState == "loading") {
        d.onreadystatechange = function () {
            if (d.readyState == "complete") {
                dycol.init();
            }
        }
    } else {
        dycol.init();
    }
})(window, document);